<div *ngIf="isChatbotEnabled">
  <div *ngIf="!isChatbotSingleClickUXEnabled" [ngClass]="{ 'no-events': disableClick }">
    <a class="regular-14 link" target="_blank" (click)="openChatbot()" data-testid="liveChatLink">
      <span data-testid="liveChat" i18n>Live Chat</span>
      <span class="new-feature text-center semi-bold-caps-10" data-testid="newFeature" i18n>new</span>
    </a>
  </div>
  
  <div *ngIf="isChatbotSingleClickUXEnabled" [ngClass]="{ 'no-events': disableClick }" (click)="toggleChatbot()" data-testid="chatbotIconDiv">
    
    <a class="regular-14 update-ux link new-sidebar-icon" [ngClass]="{ 'is-light-theme': this.isLightTheme, 'isDropdownOpen': this.isChatBotOpen }" data-testid="chatbotIcon">
      <i phx-icon [phxIcon]="circleQuestionIcon"></i>
    </a>
  </div>
</div>

<a id="pendo-feedback-link" class="d-none" target="_blank" onclick="window['pendo']?.feedback.loginAndRedirect({anchor: this});"></a>
